import { createSuccessNotification } from "@deliverr/ui-facility/lib-facility/utils/notificationUtils";
import { useIntl } from "react-intl";
import { useScanFlow } from "crossdock/common/flow/useScanFlow";
import labels from "./MovePallet.labels";

export function useMovePalletNotifications() {
  const { formatMessage } = useIntl();
  const { addAutoCloseNotification } = useScanFlow();

  const showScanStagingLaneSuccessNotification = (palletBarcode: string, laneBarcode: string) => {
    const notification = createSuccessNotification(
      formatMessage(labels.scanStagingLaneSuccessNotification, {
        palletBarcode,
        laneBarcode,
      })
    );
    addAutoCloseNotification(notification);
  };

  return {
    showScanStagingLaneSuccessNotification,
  };
}
